import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../core/services/data.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  imprintTxt!: any;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.dataService.legals$.subscribe(legals => {
      this.imprintTxt = legals;
      console.log(this.imprintTxt);
    });
  }

}
